import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';

const FollowUpsPage = () => import('./FollowUpsPage.vue');
const SequenceDetailPage = () => import('./SequenceDetailPage.vue');
const EnrollmentsPage = () => import('./EnrollmentsPage.vue');
const SettingsPage = () => import('./SettingsPage.vue');

// D21: sequence authorship is admin-only, gated on the `follow_ups` account feature flag. The
// sidebar entry and route access both resolve this meta (permissions + featureFlag).
const meta = {
  featureFlag: FEATURE_FLAGS.FOLLOW_UPS,
  permissions: ['administrator'],
};

// D31 (Story 10.9): the Enrollments view opens to agents too — the API scopes their rows by
// inbox membership; the Sequences views above stay admin-only.
const enrollmentsMeta = {
  featureFlag: FEATURE_FLAGS.FOLLOW_UPS,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/follow-ups'),
    name: 'followups_sequences_index',
    meta,
    component: FollowUpsPage,
  },
  // Declared BEFORE the :sequenceId param route on purpose (AC9): Vue Router 4 already ranks the
  // static segment higher regardless of order, but the explicit order keeps a router-upgrade
  // regression from silently routing "enrollments" into the sequence-detail page.
  {
    path: frontendURL('accounts/:accountId/follow-ups/enrollments'),
    name: 'followups_enrollments_index',
    meta: enrollmentsMeta,
    component: EnrollmentsPage,
  },
  // Story 2.4 (10.10): admin-only Settings surface. Declared BEFORE the :sequenceId param route
  // (AC6) — Vue Router 4 ranks the static segment higher regardless, but the explicit order keeps a
  // router-upgrade regression from routing "settings" into the sequence-detail page.
  {
    path: frontendURL('accounts/:accountId/follow-ups/settings'),
    name: 'followups_settings_index',
    meta,
    component: SettingsPage,
  },
  {
    path: frontendURL('accounts/:accountId/follow-ups/:sequenceId'),
    name: 'followups_sequence_detail',
    meta,
    component: SequenceDetailPage,
  },
];
